import * as Complex from '../../../../process-data/complex';

export function computeComplexAlphaMinus() {
  var result = Complex.createComplex(0, 0);
  return result;
}

export function computeComplexFF() {
  var result = Complex.createComplex(0, 0);
  return result;
}
